/* eslint no-mixed-operators: 0, spaced-comment: 0, brace-style: 0, indent: 0, no-unused-vars: 0 */

import precise from './precise';
import processPipe from './processPipe';

function getBusesBaseFeeFromWeight(options) {
  const pipeString = options.pipe;
  const pipe = processPipe(pipeString);

  const { monthsFromNow, vehicleWeight } = options;

  // Unused legacy variables from John Archer's PDF. Left here for posterity.
  const r1 = pipe.r1;
  let r12 = pipe.r12;
  let r16 = pipe.r16;
  const r17 = pipe.r17;
  const r18 = pipe.r18;

  const svc = 0;
  const rset = pipe[`r${monthsFromNow}`];

  const Z = Number(vehicleWeight);
  const K = rset;
  const W = Math.round(Z / 100);
  let total = 0;

  // monthly rate to multiply times tax months

  // NOTE: Mystery solved! All the r12 assignments are to calculate the
  // 2nd Year Fee.

  // 36 Buses, (All except private school bus)
  if ((K === 'b') && (Z !== 0)) {
      total = (((((17.00) + (2.00 * W)) / 12) * monthsFromNow) + (svc));
      console.warn('assigning a value to r12 from getBusBaseFee');
      r12 = (((((17.00) + (2.00 * W)) / 12) * 12) + (svc));
  }

  // added for base tax for 1 month fees where min 5.00 required by statute
  if ((monthsFromNow === 1) && ((((2.00 * W) / 12) * monthsFromNow) < 5)) {
      total = ((17.00) + (5.00) + (svc));
  }

  // 36 Bus 6 month semiannual except private school bus
  if (K === 's' && Z !== 0) {
    // $2.50 semi-annual fee added in fee change and 11.60
    // due to partial fees (ARF etc) for 6 month period
    total = ((((17.00) + (2.00 * W)) * 0.50) + (svc));
    console.warn('assigning a value to r12 from getBusBaseFee');
    r12 = 0;
    console.warn('attempting to assign monthsFromNow in getBusBaseFee');
  }

  // 53 Trailers Private Use over 500 lbs
  if (((K === 't') && ((Z !== 0) && (Z > 500)))) {
    total = (((((3.50) + (1.00 * W)) / 12) * monthsFromNow) + (svc));
    console.warn('assigning a value to r12 from getBusBaseFee');
    r12 = (((((3.50) + (1.00 * W)) / 12) * 12) + (svc));

    if ((K === 't') && (Z < 2000)) {
      console.warn('assigning a value to r16 from getBusBaseFee');
      r16 = 2;
    }
  }

  return precise(total);
}

export default getBusesBaseFeeFromWeight;
